import { SurroundMaterial } from '@rta/rta-blueprint-library';

import { VALID_COUNTERTOP_KEYS } from '../../../engine/builders/kitchen-scene-builder/helpers';

export const DEFAULT_SURROUND_KEY = 'stackedstone/graphite';
export const DEFAULT_COUNTERTOP_KEY = 'granite|steelgray';

/**
 * Validate and fix kitchen material keys before size calculation.
 * Invalid material keys cause getSize() to return invalid values because
 * panel thickness depends on surround material type.
 *
 * IMPORTANT: We must set `override = true` before calling setMaterial()
 * because the blueprint library's setMaterial() method checks:
 *   if (!this.initialized || this.override) { ... }
 * If initialized=true and override=false, setMaterial() silently does nothing.
 *
 * NOTE: This only fixes the material keys on the blueprint instance.
 * Panel sizing and positioning recalculation is handled by the blueprint library
 * via the @Publish event system when setMaterial() is called.
 */
export const validateAndFixMaterialKeys = (kitchen: any): void => {
	if (!kitchen?.material) return;

	// A key the library resolves in its surround catalog is valid, including legacy flat keys (e.g. "plankdarkgray")
	const surround = kitchen.material?.surround;
	if (surround && !SurroundMaterial.assetData[surround.key]) {
		console.warn(`Render3DKitchen: Invalid surround key "${surround.key}", fixing to "${DEFAULT_SURROUND_KEY}"`);
		// Must set override=true to allow setMaterial to work after initialization
		if ('override' in surround) {
			surround.override = true;
		}
		if (typeof surround.setMaterial === 'function') {
			surround.setMaterial(DEFAULT_SURROUND_KEY);
		}
	}

	// Validate countertop material
	const countertop = kitchen.material?.countertop;
	if (countertop && !VALID_COUNTERTOP_KEYS.has(countertop.key)) {
		console.warn(`Render3DKitchen: Invalid countertop key "${countertop.key}", fixing to "${DEFAULT_COUNTERTOP_KEY}"`);
		// Must set override=true to allow setMaterial to work after initialization
		if ('override' in countertop) {
			countertop.override = true;
		}
		if (typeof countertop.setMaterial === 'function') {
			countertop.setMaterial(DEFAULT_COUNTERTOP_KEY);
		}
	}
};
